import { Except } from '@common/types/common.type';
import Typography from '@ui/components/atoms/typography/typography.atom';
import { clsxm } from '@ui/utils/style.util';
import { ComponentProps, ReactNode, memo } from 'react';

export type NavbarProps = Except<ComponentProps<'header'>, 'title'> & {
  leftElement?: ReactNode;
  title: string;
  titleClassName?: string;
  toolbar?: ReactNode;
};

function BaseNavbar({
  className,
  leftElement,
  title,
  titleClassName,
  toolbar,
  ...rest
}: NavbarProps) {
  return (
    <header
      {...rest}
      className={clsxm(
        'h-16 shrink-0 px-6 bg-green shadow-button z-10 flex items-center gap-x-4',
        className,
      )}
    >
      {leftElement}
      <Typography.HeadingThree className={clsxm('text-white-yellow grow truncate', titleClassName)}>
        {title}
      </Typography.HeadingThree>
      <div className="flex items-center gap-x-4" role="toolbar">
        {toolbar}
      </div>
    </header>
  );
}
BaseNavbar.displayName = 'Navbar';

const Navbar = memo(BaseNavbar);

export default Navbar;
